import Api from './listingBatch.api.js';

import {
  filter as _filter,
  find as _find,
  forEach as _forEach,
  isEmpty as _isEmpty,
  groupBy as _groupBy,
  uniq as _uniq
} from 'lodash-es';

import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const storeList = new Api('services/', 'account');

const listingBatchService = new Api('services/', 'batch');

export const onGetDocuments = createAsyncThunk('listingBatch/onGetDocuments', async (payload, { rejectWithValue }) => {
  try {
    const apiData = await listingBatchService.onGetDocuments(payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    return rejectWithValue(error);
  }
});
